import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <CommentsSection />
        <CardsSection />
        <TopicsSection />
        <ContactSection />
        <CarouselSection />
        <FeaturesSection />
        <MediaSection />
        <FAQSection />
        <IndexSection />
        <AboutSection />
        <RankingSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}